export const SET_LICENSES = 'SET_LICENSES';
export const CLEAR_LICENSES = 'CLEAR_LICENSES';
export const CLEAR_DEFAULT_LICENSE = 'CLEAR_DEFAULT_LICENSE';
export const SET_DEFAULT_LICENSE = 'SET_DEFAULT_LICENSE';
